/*
 * Copyright 2025 Intuition Robotics ltd
 */
import React from 'react';
import '../css/style.css';

interface NavigationButtonProps {
    onClick: () => void;
    imageUrl: string;
    isNext?: boolean;
}

const NavigationButton: React.FC<NavigationButtonProps> = ({onClick, imageUrl, isNext}) => (
    <img
        className='galleryBtn'
        src={imageUrl}
        onClick={onClick}
        alt='Navigation Button'
        style={{transform: isNext === true ? 'rotateY(180deg)' : 'none'}}/>
);

export default NavigationButton;